import { render, staticRenderFns } from "./banned.vue?vue&type=template&id=7162f144"
import script from "./banned.vue?vue&type=script&lang=js"
export * from "./banned.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports